import { EventActionType } from './event-action-type';
import { EventEntry } from '../../state';

export interface LoadEventSuccessAction {
  event: Partial<
    Omit<EventEntry['event'], 'key'> & {
      occurrences: Pick<
        EventEntry['event']['occurrences'][0],
        'startsAt' | 'duration'
      >;
    }
  >;
  eventKey: string;
  type: EventActionType.LoadEventSuccess;
}

export const loadEventSuccess = (
  eventKey: string,
  event: Partial<
    Omit<EventEntry['event'], 'key'> & {
      occurrences: Pick<
        EventEntry['event']['occurrences'][0],
        'startsAt' | 'duration'
      >;
    }
  >,
): LoadEventSuccessAction => ({
  event,
  eventKey,
  type: EventActionType.LoadEventSuccess,
});
